export default "__VITE_ASSET__Dit$3763__"